import InfinitePosts from "./InfinitePosts";
import NewsItem from "./NewsItem";
import Posts from "./Posts";
import NewsCard from "./NewsCard";

export { InfinitePosts, NewsItem, Posts, NewsCard };
